import { render, staticRenderFns } from "./OrderSelect.vue?vue&type=template&id=0bbc6bcf&"
import script from "./OrderSelect.vue?vue&type=script&lang=js&"
export * from "./OrderSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dev.pixflow.app/httpdocs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('0bbc6bcf', component.options)
    } else {
      api.reload('0bbc6bcf', component.options)
    }
    module.hot.accept("./OrderSelect.vue?vue&type=template&id=0bbc6bcf&", function () {
      api.rerender('0bbc6bcf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/OrderSelect.vue"
export default component.exports